// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4860) return "static/chunks/4860.9736d603e0e7fff6.js";
	if (chunkId === 3026) return "static/chunks/3026.2aeb9ec7012cd272.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2619":"e6cb6cc2572e4af5","7520":"27d613997d36a9ab","8139":"10fae7e50f67cb5e"}[chunkId] + ".js";
};